import { Map } from 'immutable'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class TemplatesService {
  constructor(private http: HttpClient) {}

  public fetchTemplates(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/template/list`
    return this.http.post(url, params)
  }
  public fetchTemplate(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/template/${id}`
    return this.http.get(url, {})
  }

  public fetchTemplateTags(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/list/printTemplateTags`
    return this.http.post(url, {})
  }

  public deleteTemplate(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/template/${id}`
    return this.http.delete(url)
  }

  public createTemplate(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/template`
    return this.http.post(url, params)
  }

  public updateTemplate(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/template/${id}`
    return this.http.put(url, params)
  }

  public downloadTemplate(document: Map<string, any>): Observable<any> {
    let url = `${environment.API_ENDPOINT}/admin/template/${document.get(
      'id',
    )}/download`

    return this.http.get(url, {
      observe: 'response',
      responseType: 'blob' as 'json',
    })
  }

  public fetchTestTemplate(file: File, params: any): Observable<any> {
    let url: string

    if (params.templateType === 'RDN') {
      url = `${environment.API_ENDPOINT}/admin/template/testRDN/${params.propertyCode}/${params.propertyType}`
    } else if (params.templateType === 'BUSINESS') {
      url = `${environment.API_ENDPOINT}/admin/template/testBL/${params.businessCode}`
    } else if (params.templateType === 'COMPOUND') {
      url = `${environment.API_ENDPOINT}/admin/template/testCL/${params.compoundCode}`
    }

    const formData = new FormData()
    formData.append('file', file)

    return this.http.post(url, formData, {
      observe: 'response',
      responseType: 'blob' as 'json',
    })
  }
}
